import { Controller } from "@hotwired/stimulus"

// Manages week selection in the Reductie Planner calendar (Step 1)
// Clicking a week row toggles it on/off and manages hidden input fields for form submission
export default class extends Controller {
  static targets = ["weekRow", "template"]

  connect() {
    // Initialize: mark pre-selected weeks and create their hidden inputs
    this.weekRowTargets.forEach(row => {
      if (row.classList.contains("bg-amber-100")) {
        this.createHiddenInput(row.dataset.weekDate)
      }
    })
  }

  toggleWeek(event) {
    const row = event.currentTarget
    const weekDate = row.dataset.weekDate
    const isSelected = row.classList.contains("bg-amber-100")

    if (isSelected) {
      // Deselect
      row.classList.remove("bg-amber-100")
      this.removeHiddenInput(weekDate)
    } else {
      // Select
      row.classList.add("bg-amber-100")
      this.createHiddenInput(weekDate)
    }
  }

  createHiddenInput(weekDate) {
    // Check if already exists
    if (this.element.querySelector(`input[name="weeks[]"][value="${weekDate}"]`)) return

    const input = document.createElement("input")
    input.type = "hidden"
    input.name = "weeks[]"
    input.value = weekDate
    input.dataset.weekDate = weekDate
    this.element.appendChild(input)
  }

  removeHiddenInput(weekDate) {
    const input = this.element.querySelector(`input[name="weeks[]"][value="${weekDate}"]`)
    if (input) input.remove()
  }
}
